import React, { Component } from "react"
import { Modal, Input, Form, Button } from '@drifthq/tide-core'
import PropTypes from "prop-types"
import InstallNotification from "components/OnboardingInstallNotification"
import { track } from 'utils/trackingUtils'
import { pathOr } from 'ramda'
import { isEmail } from 'validator'
import { api } from 'modules/org/api'

import './style.css'

const EMAIL_BODY = <div>Hello! Can you help me install Drift on our website? It shouldn’t take more than 2 minutes. You can find the code snippet below, and instructions on how to install using Javascript <a href="https://help.drift.com/article/install-drift-on-your-website-javascript/" target="_blank" rel="noopener noreferrer"> here</a>.<br /><br />[Drift code will appear here]</div>
const ERROR_MESSAGE = "Uh oh! Something went wrong when we tried to send the email. Try again!"
class EmailSnippetModal extends Component {

  static propTypes = {
    onClose: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
  }

  state = {
    email: '',
    showErrorNotification: false,
    isValid: false,
  }

  onSubmit = e => {
    e.preventDefault()
    const { email } = this.state
    api.shareEmailSnippet(email)
      .then(this.onShareSnippetSuccess)
      .catch((e) => this.onShareSnippetError(e))
  }

  onEmailChanged = (event) => {
    const changedValue = pathOr('', ['target', 'value'], event)
    const isValid = changedValue && isEmail(changedValue)
    this.setState({ email: changedValue, isValid })
  }

  onShareSnippetSuccess = () => {
    const { email } = this.state
    const { onClose, name } = this.props
    onClose()
    track(`${name} Install Modal - Teammate Request Email Sent`, {
      context: 'email-snippet-modal',
      requestedEmail: email,
    })
    this.setState({ showErrorNotification: false })
  }

  onShareSnippetError = (e) => {
    const { email } = this.state
    const { name } = this.props
    track(`${name} Install Modal - Teammate Request Email Error`, {
      context: 'email-snippet-modal',
      requestedEmail: email,
    })
    this.setState({ showErrorNotification: true })
  }

  render() {
    const { onClose } = this.props
    const { email, showErrorNotification, isValid } = this.state
    return (
      <Modal open={true} onClose={onClose} className="email-invite-modal" size="small">
        <div className="email-invite-header">Send to a teammate</div>
        <Form onSubmit={this.onSubmit}>
          <Input
            label="Send to"
            type="email"
            value={email}
            placeholder="Enter a teammate's email address"
            onChange={this.onEmailChanged}
            className="email-invite-email-input"
          >
          </Input>
          <div className="email-invite-message-body-label">Message</div>
          <div className="email-invite-message-body">{EMAIL_BODY}</div>
          <InstallNotification
            errorText={ERROR_MESSAGE}
            isError={showErrorNotification}
          />
          <Button submit
            disabled={!isValid}
            onClick={this.onSubmit}
            type='secondary'
            className="email-invite-submit-button"
          >
            Send Message
          </Button>
          <Button
            onClick={onClose}
            type='tertiary'
            className="email-invite-cancel-button"
          >
            Nevermind
          </Button>
        </Form>
      </Modal>
    )
  }
}

export default EmailSnippetModal



// WEBPACK FOOTER //
// ./src/layouts/OnboardingInstallStep/EmailSnippetModal/index.js